/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetUserFavoriteGachasResponse } from '../../models/set-user-favorite-gachas-response';
import { UserServiceSetUserFavoriteGachasRequest } from '../../models/user-service-set-user-favorite-gachas-request';

export interface UserServiceSetUserFavoriteGachas$Params {
  userUuid: string;
      body: UserServiceSetUserFavoriteGachasRequest
}

export function userServiceSetUserFavoriteGachas(http: HttpClient, rootUrl: string, params: UserServiceSetUserFavoriteGachas$Params, context?: HttpContext): Observable<StrictHttpResponse<SetUserFavoriteGachasResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceSetUserFavoriteGachas.PATH, 'post');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SetUserFavoriteGachasResponse>;
    })
  );
}

userServiceSetUserFavoriteGachas.PATH = '/api/v3/gateway/user/{userUuid}/favorite/gacha';
